import { Container, Nav, Navbar } from "react-bootstrap";
import logo from "./Shihabun shakib.png";
import "./NavBar.css";
import { Link } from "react-scroll";

export default function NavBar() {
  return (
    <div id="navbar">
      <Container>
        <Navbar data-aos="fade-down" expand="md">
          <Link to="#home" className="logo navbar-brand">
            <img src={logo} alt="LOGO" />
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto navMenu mobileNavMenu">
              <Link to="aboutMe" smooth={true} duration={1000} className="nav-link">
                <span>About</span>
              </Link>
              <Link to="skills" smooth={true} duration={1000} className="nav-link">
                <span>Skills</span>
              </Link>
              <Link to="portfolio" smooth={true} duration={1000} className="nav-link">
                <span>Portfolio</span>
              </Link>
              <Link to="blog" smooth={true} duration={1000} className="nav-link">
                <span>Blog</span>
              </Link>
              <Link to="contact" smooth={true} duration={1000} className="nav-link">
                <span>Contact</span>
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </div>
  );
}
